<template>
  <div class="page6" :class="'footer-'+zhoren">
     <div class="page6_footer">
          <div class="footer_center">
            <img class="footer-logo" src="@/assets/images/footer/footer_logo.png" />
            <ul>
           
              <!-- <li>
                <ul>
                  <li class="title">{{$t('about_qqyh_qyzz')}}</li>
                  <li>{{$t('about_qqyh_rtxmynydh')}}</li>
                </ul>
              </li> -->
              <li>
                <ul>
                  <li class="title">{{$t('layout_myservice')}}</li>
                  <li><router-link to="/index/ourServer?index=0" tag="a" target="_blank">{{$t('page1item1')}}</router-link></li>
                  <li><router-link to="/index/ourServer?index=1" tag="a" target="_blank">{{$t('page1item2')}}</router-link></li>
                  <li><router-link to="/index/ourServer?index=2" tag="a" target="_blank">{{$t('page1item3')}}</router-link></li>
                  <li><router-link to="/index/ourServer?index=3" tag="a" target="_blank">{{$t('page1item4')}}</router-link></li>
                  <li><router-link to="/index/ourServer?index=4" tag="a" target="_blank">{{$t('page1item5')}}</router-link></li>
                  <li><router-link to="/index/ourServer?index=5" tag="a" target="_blank">{{$t('page1item6')}}</router-link></li>
                  <!-- <li><router-link to="/index/file" tag="a" target="_blank">{{$t('page1item7')}}</router-link></li> -->
                </ul>
              </li>
              <li>
                <ul>
                  <li class="title">{{$t('layout_zyzx')}}</li>
                  <li><router-link to="/index/file" tag="a" target="_blank">{{$t('page1item7')}}</router-link></li>
                  <!-- <li><router-link to="" tag="a" target="_blank">{{$t('layout_myszy')}}</router-link></li>
                  <li><router-link to="" tag="a" target="_blank">{{$t('layout_yhyzy')}}</router-link></li>
                  <li><router-link to="" tag="a" target="_blank">{{$t('layout_xwbk')}}</router-link></li>
                  <li><router-link to="" tag="a" target="_blank">{{$t('layout_jybg')}}</router-link></li>
                  <li><router-link to="" tag="a" target="_blank">{{$t('layout_yhkt')}}</router-link></li> -->
                </ul>
              </li>
              <!-- <li>
                <ul>
                  <li class="title">{{$t('layout_gywm')}}</li>
                  <li>
                    <router-link to="/index/aboutUs" tag="a" target="_blank">{{$t('layout_gsjs')}}</router-link>
                  </li>
                  <li>
                    <router-link to="/index/aboutUs?tab=3" tag="a" target="_blank">{{$t('layout_jrwm')}}</router-link>
                  </li>
                </ul>
              </li> -->
             
              <li>
                <ul>
                  <li class="title">{{$t('layout_lxkf')}}</li>
                  <li>{{$t('layout_email')}}：{{KefuInfo.email}}</li>
                  <li>{{$t('layout_zhixun')}}：{{KefuInfo.mobile}}</li>
                  <!-- <li>{{$t('layout_hotline')}}：{{KefuInfo.phone}}</li> -->
                  <!-- <li>{{$t('layout_wxkf')}}：{{KefuInfo.wechat_photo}}</li> -->
                  <li>Facebook：insp03@inspector.ltd</li>
                  <li>WhatsApp：0086-18094507770</li>
                </ul>
              </li>
              <!-- <li>
                <ul>
                  <li class="title">{{$t('layout_help')}}</li>
                  <li>{{$t('layout_ybxz')}}</li>
                  <li>{{$t('layout_czzy')}}</li>
                  <li>{{$t('layout_hqjf')}}</li>
                  <li>{{$t('layout_jfgz')}}</li>
                </ul>
              </li> -->
            </ul>
            <dl>
              <dd>
                <img :src="$host.file + Android_code" />
                <span>{{$t('azxz')}}</span>
              </dd>
              <dd>
                <img :src="$host.file + ios_code" />
                <span>{{$t('pgxz')}}</span>
              </dd>
              <dd>
                <img :src="$host.file + customer_code" />
                <span>{{$t('wxkf')}}</span>
              </dd>
            </dl>
          </div>
        </div>
    <footer>
      <!-- <div class="footer-nav">
        <div class="img-box">
          <img src="../../assets/fullpageImage/page6-logo.png" />
        </div>
        <div class="nav">
          <router-link tag="a" to="/index/aboutUs">{{
            $t("layout_gsjs")
          }}</router-link>
          <router-link tag="a" to="/index/aboutUs?tab=3">{{
            $t("layout_jrwm")
          }}</router-link>
          <router-link tag="a" to="/">积分获取</router-link>
          <router-link tag="a" to="/">积分规则</router-link>
        </div>
      </div> -->
      <p>Copyright@2006-2021 <a href="https://beian.miit.gov.cn/" target="_blank">浙ICP备14032340号</a></p>
    </footer>
  </div>
</template>

<script>
import $ from "jquery";
import { service } from "@/api/login.js";
import { getCustomer, addressSearchFromGaode } from "@/api/webKefu";
export default {
  name: "page6",
  data() {
    return {
      zhoren: localStorage.getItem("locale") || "zh",
      Android_code: "",
      ios_code: "",
      customer_code:"",
        KefuInfo: {},
    };
  },
  created() {
    // this.getService();
    //  this.getCustomer();
    const _this = this
    this.$store.dispatch('global/getCustomer').then(() => {
      _this.KefuInfo = _this.$store.state.global.KefuInfo;
      _this.Android_code = _this.KefuInfo.Android_code;
      _this.ios_code = _this.KefuInfo.ios_code;
      _this.customer_code = _this.KefuInfo.customer_code[0]
      localStorage.setItem("KefuInfo", JSON.stringify(_this.KefuInfo));
    });
  },
  methods: {
    // async getCustomer() {
    //   const res = await getCustomer();
    //   const { code, data } = res.data;
    //   if (code == 200) {
    //     this.KefuInfo = data;
    //     this.Android_code = data.Android_code;
    //     this.ios_code = data.ios_code;
    //     this.customer_code = data.customer_code[0]
    //     localStorage.setItem("KefuInfo", JSON.stringify(data));
    //   }
    // },
    openChat() {
      let userInfo = JSON.parse(localStorage.getItem("userInfo"))
        ? JSON.parse(localStorage.getItem("userInfo"))
        : "";
      let newObj = {};
      if (userInfo) {
        newObj = this.$router.resolve({ path: "/groupchat" });
      } else {
        newObj = this.$router.resolve({ path: "/visitorchat" });
      }
      window.open(newObj.href, "_blank");
    },
    // async getService() {
    //   const res = await service();
    //   let { code, data } = res.data;
    //   this.Android_code = data.Android_code;
    //   this.ios_code = data.ios_code;
    //   this.customer_code = data.customer_code[0]
    // },
  },
  mounted() {},
  watch: {
    "$route.hash": {
      handler(val) {
        if (this.$route.hash === "#page6") {
          if (!$(".page6-shao-ani").eq(0).hasClass("animated")) {
            $(".page6-shao-ani").css({ visibility: "hidden" });
          }
          setTimeout(function () {
            $(".page6-shao-ani")
              .eq(0)
              .css({ visibility: "visible" })
              .addClass("animated fadeInRightBig");
          }, 1000);
          for (let i = 1; i < 10; i++) {
            setTimeout(function () {
              $(".page6-shao-ani")
                .eq(i)
                .css({ visibility: "visible" })
                .addClass("animated fadeInUp");
            }, 1000 + 300 * i);
          }
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped lang='scss'>
$width: 19.2px;
.page6_footer {
  background: #ffffff;
  display: block;
  height: auto;
  .footer_center {
    display: flex;
    align-items: top;
   /* width:1200px;*/
    width:1400px;
    padding: 70px 20px 70px 20px;
    box-sizing: border-box;
    margin: 0 auto;
    .footer-logo {
      width: 164px;
      height: 110px;
      margin-right: 56px;
    }
    & > ul {
      display: flex;
      align-items: top;
      width: 750px;
      height: auto;
      & > li {
        min-width: 21%;
        display: inline-block;
        vertical-align: top;
        text-align: left;
      }
      li {
        margin: 8px 0 5px 0px;
        font-size: 14px;
        &.title {
          font-size: 20px;
          margin-bottom: 10px;
          padding-left: 10px;
          font-weight: bold;
          border-left: 3px solid #D71515;
        }
      }
      li:not(:first-child) {
        margin: 8px 0px 5px 13px;
      }
    }
    & > dl {
      display: flex;
      justify-content: space-between;
      width: 450px;
      dd {
        width: 28%;
        margin: 10px 2% 0 2%;
        img {
          width: 100%;
        }
        span {
          color: #999;
          font-size: 12px;
          text-align: center;
          line-height: 30px;
          display: block;
        }
      }
    }
  }
  .footer_bot {
    padding: 20px;
    background: #c9c9c9;
    color: #333;
    .footer_center_bt {
      margin: 0 auto;
      text-align: center;
      font-size: 12px;
      li {
        display: inline-block;
        img {
          margin-right: 20px;
          width: 80px;
          height: 30px;
        }
      }
      p {
        margin: 10px 0;
      }
    }
  }
  
}
.page6{
  & >footer{
    display: flex;
    justify-content: center;
    background: #ffffff;
    height: 77px;
    line-height: 77px;
    font-size: 16px;
    color: #CACACA;
    border-top: 1px solid #efefef;
  }
}
@media screen and (max-width: 720px) {
  .page6_footer {
    .footer-logo {
      display: none;
    }
    .footer_center {
      display: flex;
      align-items: top;
      flex-wrap: wrap;
      width:100%;
      padding: 10px 20px;
      box-sizing: border-box;
      margin: 0 auto;
      & > ul {
        display: flex;
        align-items: top;
        width: 100%;
        height: auto;
        & > li {
          min-width: 24%;
          display: inline-block;
          vertical-align: top;
          text-align: left;
        }
        & > li:first-child {
          // display: none;
        }
        li {
          margin: 8px 0px 5px 0px;
          font-size: 14px;


          &.title {
            font-size: 16px;
            margin-bottom: 10px;
            padding-left: 6px;
            font-weight: bold;
            border-left: 4px solid #fa7202;
          }
        }
        li:not(:first-child) {
          margin: 8px 0px 5px 10px;
        }
      }
      & > dl {
        display: flex;
        justify-content: space-between;
        width: 100%;
        dd {
          width: 28%;
          margin: 10px 2% 0 2%;
          img {
            width: 100%;
          }
          span {
            color: #999;
            font-size: 12px;
            text-align: center;
            line-height: 30px;
            display: block;
          }
        }
      }
    }
    .footer_bot {
      padding: 20px;
      background: #c9c9c9;
      color: #333;
      .footer_center_bt {
        margin: 0 auto;
        text-align: center;
        font-size: 12px;
        li {
          display: inline-block;
          img {
            margin-right: 20px;
            width: 80px;
            height: 30px;
          }
        }
        p {
          margin: 10px 0;
        }
      }
    }
  }
}
</style>